<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>收款信息</span>
      </div>
      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收款编号：">{{ bankformList.receiptNumber }}</el-form-item>
            <!-- bankformList.bizNumber -->
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款方式：">
              {{ bankformList.receiptClass}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款类型：">{{bankformList.receiptType}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="状态：">{{states(bankformList.state)}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="票据金额：">{{bankformList.billMoney | billMoney}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="bankformList.cusId" label="客户名称：">{{bankformList.cusName}}</el-form-item>
            <el-form-item v-else label="供应商名称：">{{bankformList.cusName}}</el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="备注：">{{bankformList.mark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="item-box-content">
      <el-form class="details-line-height" style="padding:20px 30px 0 30px" :model="bankformList">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="承兑汇票：">{{bankformList.billNumber}}</el-form-item>
            <!-- bankformList.bankName -->
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票单位：">{{bankformList.billCompany}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票行：">{{bankformList.billBank}}</el-form-item>
            <!-- bankformList.receiptOpenBank | -->
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="出票日期：">{{formatData(bankformList.billDate) | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="到期日期："> {{bankformList.billEnddate | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8" v-if="bankformList.billAttachment">
            <el-form-item label="付款凭证：">
              <div class="down">
                <el-button type="text" @click="onSee(bankformList.billAttachment)">查看</el-button>
                <el-button type="text" @click="downloadFile(bankformList.billAttachment)">下载</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>审核</span>
      </div>
      <el-form style="padding:20px 30px 0 30px" :model="bankformList">
        <el-form-item prop="state" label="审核结果：">
          <el-radio v-model="radio" label="2">确认收款</el-radio>
          <el-radio v-model="radio" label="3">核审不通过</el-radio>
        </el-form-item>
        <el-form-item
          prop="exPlain"
          label="备注："
        >
          <el-input
            v-model="chioes"
            style="width:93%"
            type="textarea"
            :rows="3"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
        <el-button type="primary" letter-spacing @click="submitBtn">提交</el-button>
      </el-form>
    </div>

    <operation-log-and-flow :flowLabel="flowLabel" :id="id"></operation-log-and-flow>
    <!-- 弹框 -->
    <el-dialog title="确认提交" :visible.sync="dialogVisible" width="480px">
      <div style="padding:0 30px">
        <div style="padding-bottom: 15px;">确定承兑汇票收款：{{bankformList.billMoney | toFixed}}</div>
        <div style="margin-bottom: 20px;">确定提交收款？提交后无法撤回，请谨慎操作</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureBtn()">确 定</el-button>
      </span>
    </el-dialog>
    <brand-dialog ref='brandDialogRef' :title="`查看`"></brand-dialog>
  </div>
</template>
<script>
import noticeApi from '@/api/workbench/notice'
import { downLoadFile, isSuccess } from '@/util/tool'
import {
  queryByOrderId,
  updateStateByFbrIdup
} from '@/api/fiance/fianceManage'
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow'
import { formatData } from '@/util/filterCommon'
import BrandDialog from '@/views/crm/components/supplier/dialog/brandDialog'
import checkApi from '@/api/workbench/check'

export default {
  components: {
    BrandDialog,
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {
      flowLabel: '签署流程',
      mark: '',
      dialogVisible: false,
      value: '',
      reverse: true,
      id: '',
      bankformList: {},
      params: {},
      textarea: '',
      radio: '2',
      rules: { mark: { required: true, message: '必填' } },
      orderContractStockup: {},
      confirmState: 0,
      chioes: ''
    }
  },
  filters: {
    billMoney (billMoney) {
      if (!billMoney) {
        return ''
      }
      return billMoney.toFixed(2)
    }
  },
  mounted () {
    this.id = this.$route.query.fabrId
    queryByOrderId(this.$route.query.fabrId)
      .then((res) => {
        if (res.data.code === 200) {
          this.bankformList = res.data.obj
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },

  methods: {
    formatData,
    // 查看
    onSee (attachment) {
      if (attachment && attachment[0]) {
        const guid = attachment[0]
        checkApi.getPactFileUrl({ guid: attachment }).then(res => {
          if (isSuccess(res)) {
            const { filePath } = res.data.obj
            if (filePath) {
              const file = filePath.split('.')
              const fileType = file[file.length - 1]
              this.$refs.brandDialogRef.onBlackDialog([{
                filePath,
                fileExt: '.' + fileType
              }])
            }
          }
        })
      }
    },
    states (state) {
      // console.log(payType)
      if (state === 1) {
        return '收款审核'
      } else if (state === 2) {
        return '收款成功'
      } else if (state === 3) {
        return '收款审核不通过'
      }
    },
    // 获取公告详情
    queryNoticeDetail (snIdex) {
      let { snId } = this
      if (snIdex) {
        snId = snIdex
      }
      noticeApi
        .queryNoticeDetail({
          snId
        })
        .then((res) => {
          if (isSuccess(res)) {
            this.noticeDetailsObj = res.data.obj
            this.lastSnId = res.data.obj.lastSnId
            this.nextSnId = res.data.obj.nextSnId
          } else {
            this.$message({
              message: res.data.msg
            })
          }
        })
    },
    // 文件下载
    downloadFile (guid) {
      noticeApi
        .downloadNoticeFile({
          guid
        })
        .then((res) => {
          downLoadFile(res)
        })
    },
    submitBtn () {
      if (this.chioes === '' && this.radio === '3') {
        this.$message.error('请填写备注')
        return
      }
      this.dialogVisible = true
    },
    // 二次确定
    sureBtn () {
      const paramsbank = {
        id: this.bankformList.id,
        mark: this.chioes,
        cusId: this.bankformList.cusId
      }
      updateStateByFbrIdup(Number(this.radio), 3, paramsbank)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('处理成功')
            this.$router.replace('acceptDraftCollectionsManage')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      // this.dialogVisible = false
      // if (!this.bankformList.mark) {
      //   this.$message.error('审核结果不为通过时，备注不可为空！！')
      //   return
      // }
      // this.$message({
      //   message: '提交成功！！',
      //   type: 'success'
      // })
      // this.$router.push('/finance/financeManage/acceptDraftCollectionsManage')
    }
  }
}

</script>
<style lang="scss" scoped>
  .pay {
    padding-top: 8px;
    font-weight: bold;
  }

  .look {
    color: blue;
    padding-left: 20px;
  }

  .down {
    margin: -6px;

  }
</style>
